/**
 * Icons Ribbon Section with Splide
 * - Auto slider on mobile with 5s interval
 * - No arrows or pagination
 * - Centered single item per page
 * - Responsive: destroys/remounts on window resize
 */

window.initIconsRibbonSlider = function (container) {
  const slider = container.querySelector('.icons-ribbon__slider');
  const mobileLayout = container.dataset.mobileLayout; 

  if (!slider || typeof Splide === 'undefined' || mobileLayout !== 'slider') {
    return null;
  }

  let splideInstance = null;

  const isMobile = () => window.innerWidth < 1100;

  const mountSlider = () => {
    if (!isMobile() || splideInstance) return;

    splideInstance = new Splide(slider, {
      type: 'loop',
      perPage: 1,
      perMove: 1,
      gap: 0,
      arrows: false,
      pagination: false,
      drag: true,
      autoplay: true,
      interval: 5000,
      pauseOnHover: true,
      pauseOnFocus: true,
      speed: 800,
      easing: 'ease',
      direction: 'ltr',
      trimSpace: false,
      focus: 0,
      updateOnMove: true,
      i18n: {
        carousel: 'Feature icons carousel',
        slide: 'feature',
        slideLabel: '%s of %s',
      }
    });

    splideInstance.mount();
    container.splideInstance = splideInstance;
  };

  const destroySlider = () => {
    if (splideInstance) {
      splideInstance.destroy();
      splideInstance = null;
      container.splideInstance = null;
    }
  };

  const handleResize = () => {
    if (isMobile()) {
      mountSlider();
    } else {
      destroySlider();
    }
  };

  // Initial mount
  handleResize();

  // Handle window resize with debounce
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(handleResize, 150);
  });

  return splideInstance;
};

// Initialize on load
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.icons-ribbon');
  containers.forEach(container => {
    window.initIconsRibbonSlider(container);
  });
});

// Shopify theme editor support
if (typeof Shopify !== 'undefined' && Shopify.designMode) {
  document.addEventListener('shopify:section:load', function (event) {
    const container = event.target.querySelector('.icons-ribbon');
    if (container) {
      window.initIconsRibbonSlider(container);
    }
  });

  document.addEventListener('shopify:section:unload', function (event) {
    const container = event.target.querySelector('.icons-ribbon');
    if (container && container.splideInstance) {
      container.splideInstance.destroy();
    }
  });
}
